// extracted by mini-css-extract-plugin
module.exports = {"title":"FooterPayments_title__oLyqz"};